import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Topnav from "../common/Topnav";
import Footer from "../common/Footer";
import { Link } from "react-router-dom";
import faqBanner from "../../Images/student-services/ragging.webp";
import classroomImage from "../../Images/gov-body/rules.webp";

// Form list
const forms = [
    { name: "Application form for Provisional & Transcript Certificate", file: require("../../Images/FORM/Application form for Provisional & Transcript Certificate.pdf") },
    { name: "ATKT/Supplementary Form", file: require("../../Images/FORM/ATKT_FORM.pdf") },
    { name: "Application for Issue of Bonafide Certificate", file: require("../../Images/FORM/BONAFIDE_APPLICATION_FORM.pdf") },
    { name: "Procedure for Change of Name and Surname", file: require("../../Images/FORM/Change of Name and Surname form.pdf") },
    { name: "Application Form for Issue of Degree Certificate", file: require("../../Images/FORM/Degree Form.pdf") },
    { name: "Application Form for Issue of Diploma/PG Diploma Certificate", file: require("../../Images/FORM/DiplomaCertificate.pdf") },
    { name: "Application Form for Issue of Duplicate Mark sheet", file: require("../../Images/FORM/Duplicate marksheet form.pdf") },
    { name: "Fee Installment Declaration Form", file: require("../../Images/FORM/Fee istallment declaration form (1).pdf") },
    { name: "Admission form", file: require("../../Images/FORM/isbm university Admission form.pdf") },
    { name: "Bus Facility Form", file: require("../../Images/FORM/isbm university new - bus facility form.pdf") },
    { name: "Hostel Form", file: require("../../Images/FORM/isbm university new - Hostel form.pdf") },
    { name: "Application for Transfer Certificate/ Migration Certificate/ Character Certificate", file: require("../../Images/FORM/isbm university new - ND for TC-CC-MG.pdf") },
    { name: "No Dues Form", file: require("../../Images/FORM/isbm university new - No Dues Form.pdf") },
    { name: "Readmission Form", file: require("../../Images/FORM/Re Registration form.pdf") },
];

const Downloads = () => {
    // Split the forms into 2 columns
    const midIndex = Math.ceil(forms.length / 2);
    const firstColumnForms = forms.slice(0, midIndex);
    const secondColumnForms = forms.slice(midIndex);

    const renderFormList = (formList) => (
        <ul className="form-list no-marker">
            {formList.map((form, index) => (
                <li className="downloadform-card" key={index}>
                    <div className="formIcon">
                        <i className="fa fa-wpforms" aria-hidden="true"></i>
                    </div>
                    <div className="formname d-flex justify-content-between align-items-center w-100">
                        <a
                            href={form.file}
                            target="_blank"
                            rel="noopener noreferrer"
                            download
                            className="form-link"
                        >
                            {form.name}
                        </a>
                        <a
                            href={form.file}
                            target="_blank"
                            rel="noopener noreferrer"
                            download
                            className="download-icon"
                            aria-label="Download"
                        >
                            <i className="fa fa-download " aria-hidden="true"></i>
                        </a>
                    </div>
                </li>
            ))}
        </ul>
    );

    return (
        <>
            <title>Download Forms | ISBM University</title>
            <meta
                name="description"
                content="Access all necessary application and institutional forms for ISBM University here. Download your required forms easily and get started today."
            />
            <Topnav />
            <section
                className="section-hero-banner ptb-50"
                style={{
                    backgroundImage: `linear-gradient(rgba(28,36,71,0.8), rgba(28,36,71,0.8)), url(${faqBanner})`,
                }}
            >
                <div className="banner-hero-overlay">
                    <div className="container-xxl">
                        <div className="section-hero-content">
                            <h1>Download</h1>
                            <ol className="breadcrumb mt-3 text-center mb-0">
                                <li className="breadcrumb-item">
                                    <Link to="/" style={{ color: "#fff", textDecoration: "none" }}>
                                        Home
                                    </Link>
                                </li>
                                <li className="breadcrumb-item active text-white" aria-current="page">
                                    Download
                                </li>
                                <hr className="section-divider" />
                            </ol>
                        </div>
                    </div>
                </div>
            </section>

            <section className="bg-light">
                <div className="container-xxl ptb-50">
                    <Row className="m-0">
                        <div className="col-md-6">
                            <div className="governing-image-wrapper shadow">
                                <img src={classroomImage} alt="Governing Body" />
                            </div>
                        </div>
                        <div className="col-md-6">
                            <h2 className="modern-title text-blue">Download Center</h2>
                            <div className="underline-divider mb-3"></div>
                            <p className="text-muted">
                                ISBM University offers a centralized Download Center where students,
                                faculty, and stakeholders can access important academic and administrative
                                resources. From admission forms, academic calendars, and examination schedules
                                to policy documents and student handbooks — all essential materials are
                                available for easy and quick download.
                            </p>
                            <p className="text-muted">
                                This user-friendly section ensures that all relevant documents are just
                                a click away, supporting transparency and efficient communication.
                                Whether you're a new applicant or an enrolled student, our download portal
                                helps you stay informed and organized throughout your academic journey at
                                ISBM University.
                            </p>
                        </div>
                    </Row>
                </div>
            </section>

            <Container className="About_us11 py-5 container-xxl">
                <Row>
                    <Col lg={12}>
                        <h2 className="linkabout123">Download</h2>
                        <Row>
                            <Col md={6}>{renderFormList(firstColumnForms)}</Col>
                            <Col md={6}>{renderFormList(secondColumnForms)}</Col>
                        </Row>
                    </Col>
                </Row>
            </Container>

            <Footer />
        </>
    );
};

export default Downloads;
